import { ContentSection } from './ContentSection';
import { PageWithHeader } from './PageWithHeader';

export const Layout = {
  ContentSection,
  PageWithHeader,
};
